/** 原采购深链继续使用 / 和原权限键；无业务参数的打开动作进入轻量首页。 */
export function hasProcurementQuery(search: string): boolean {
  const params = new URLSearchParams(search);
  return params.get('workspace') === 'procurement' ||
    ['view', 'warn', 'material', 'material_code', 'code', 'supplier', 'buyer'].some(key => params.has(key));
}
